export const PreventiveMaintenancePlanPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
} as const;

export type PreventiveMaintenancePlanPriority =
  (typeof PreventiveMaintenancePlanPriority)[keyof typeof PreventiveMaintenancePlanPriority];
